<template>
  <div>
    <ViewTemplateReportList
      :panel="panel"
      :reports="reports"
    />
  </div>
</template>

<script>
import ViewTemplateReportList from "@nixweb/nixloc-ui/src/component/template/ViewTemplateReportList";

export default {
  name: "RelatorioStockView",
  components: { ViewTemplateReportList },
  data() {
    return {
      panel: {
        module: "Estoque",
        title: "Relatório",
        showFilter: false,
        showSearch: true,
        showButtons: false,
      },
      reports: {
        default: [
          {
            name: "Produtos",
            routeName: "reportStockProduct",
          },
          {
            name: "Produtos por Cliente",
            routeName: "reportStockProductByCustomer",
          },
          {
            name: "Patrimônios",
            routeName: "reportStockPatrimony",
          },
          {
            name: "Histórico de Patrimônios",
            routeName: "reportStockHistoryPatrimony",
          },
        ],
        saved: [],
      },
    };
  },
};
</script>
